import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { EnrollmentDocumentType, EnrollmentType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { ENROLLMENTS_DOCUMENTS } from "../../../utils/constants";

export const getEnrollmentsDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdEnrollment ? { IdEnrollment: data.IdEnrollment } : {}),
    });
    const url = `${ENROLLMENTS_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<EnrollmentDocumentType>>(url)
};